import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-est',
  templateUrl: './est.component.html',
  styleUrls: ['./est.component.css']
})
export class EstComponent implements OnInit {

  constructor(
    private router: Router,
  ) { }

  token = JSON.parse(localStorage.getItem('token'));

  ngOnInit(): void {
    if (this.token != 'estudiante' && this.token != 'superadmin' && this.token != 'administrador' && this.token != 'editor') {
      this.router.navigate([''])
    }
  }

}

